<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Add Student </strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span
          v-if="
            this.org_id == 'zeal' ||
            this.org_id == 'sbpps' ||
            this.org_id == 'vvp'
          "
        >
          <v-toolbar-title v-if="this.serial_track">
            <strong>
              Next PRN Generated Will Be : {{ this.serial_track }} (For
              AcademicYear - {{ this.curreny_academicyear }})
            </strong>
          </v-toolbar-title>
        </span>
      </v-toolbar>
      <v-row justify="center" dense>
        <!-- {{generate_grno}}{{generate_parent_email}} -->
        <v-col cols="12" sm="2">
          <p><b>Batch</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="ay"
            :items="ay_list"
            item-text="ay"
            item-value="id"
            label="Academic Year"
            @change="
              clearList();
              getNextPRN();
            "
            outlined
          />
        </v-col>
        <!-- <v-col cols="12" sm="2">
                    <p><b>Semester</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sem" :items="sem_list" item-text="sem" item-value="id" label="Semester" outlined />
                </v-col> -->
        <!-- <v-col cols="12" sm="2">
                    <p><b>Stream</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stream" :items="stream_list" item-text="name" item-value="id" label="Stream" outlined />
                </v-col> -->
        <v-col cols="12" sm="2">
          <p><b>Class</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="standard"
            :items="standard_list"
            item-text="standard"
            item-value="id"
            label="Standard"
            @change="getDivisions(standard)"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="2" v-if="this.division_list.length > 0">
          <p><b>Division</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="division"
            :items="division_list"
            item-text="division"
            item-value="div_off_id"
            label="Division"
            @change="setFlag"
            outlined
          />
        </v-col>
      </v-row>
      <v-row justify="center" dense v-if="show_info_card">
        <v-col cols="12" sm="1"></v-col>
        <v-col cols="12" sm="3">
          <p>
            <b>Number Of Offered Subjects - {{ subject_offerings }}</b>
          </p>
        </v-col>
        <v-col cols="12" sm="3">
          <p>
            <b>Number Of Compulsory Subjects - {{ crs_off }}</b>
          </p>
        </v-col>
        <v-col cols="12" sm="3"
          ><p>
            <b>Number Of Fees Structure Installments - {{ installments }}</b>
          </p></v-col
        >
      </v-row>
    </v-card>
    <v-card class="box" v-if="this.showstudentdetailscard">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Student Details </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="2">
          <p>
            <b>First Name <v-icon color="error">*</v-icon></b>
          </p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="first_name"
            name="first_name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Middle Name</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="middle_name"
            name="middle_name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <p>
            <b>Last Name<v-icon color="error">*</v-icon></b>
          </p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="last_name"
            name="last_name"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3" md="2">
          <p>
            <b>DOB<v-icon color="error">*</v-icon></b>
          </p>
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Select Date Of Birth"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" scrollable
              ><v-spacer></v-spacer
              ><v-btn text color="primary" @click="modal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(date)"
                >OK</v-btn
              ></v-date-picker
            >
          </v-dialog>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="3" md="2">
          <p>
            <b>Gender<v-icon color="error">*</v-icon></b>
          </p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="gender"
            :items="gender_list"
            item-text="name"
            item-value="id"
            label="Gender"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Blood Group</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="blood_group"
            :items="blood_group_list"
            item-text="name"
            item-value="id"
            label="Blood Group"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p>
            <b>Quota<v-icon color="error">*</v-icon></b>
          </p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="quota"
            :items="quota_list"
            item-text="name"
            item-value="id"
            label="Quota"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p>
            <b>Religion</b>
          </p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="stud_religion"
            :items="religion_list"
            item-text="name"
            item-value="id"
            label="Religion"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2" v-if="!check_for_duplicate_data">
          <p><b>Aadhaar No</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="aadhar_no"
            name="aadhar_no"
          ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3" md="2" v-else>
          <p><b>Aadhar Number</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="aadhar_no"
            name="aadhar_no" 
            @change="checkforaadharno()"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="2">
          <p>
            <b
              >Category<v-icon color="error" v-if="!this.org_id == 'zeal'"
                >*</v-icon
              ></b
            >
          </p>
          <v-autocomplete 
            color="#0F2027"
            dense
            rounded
            required
            v-model="category"
            :items="category_list"
            item-text="name"
            item-value="id"
            label="Category"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Cast</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="stud_caste"
            :items="caste_list"
            item-text="name"
            item-value="id"
            label="Cast"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>House</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="stud_house"
            :items="house_list"
            item-text="name"
            item-value="id"
            label="House"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Roll No</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="roll_no"
            name="roll_no"
          ></v-text-field>
        </v-col>

        <!-- <v-col cols="12" sm="2" v-if="!this.generate_grno">
             <p><b>GR No</b></p>
               <v-text-field outlined dense type="text" v-model="grno" label="GR Number" name="grno"></v-text-field>
        </v-col> -->
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="2" v-if="!this.generate_parent_email">
          <p>
            <b
              >Parent Email / Username<v-icon
                color="error"
                v-if="!this.org_id == 'zeal'"
                >*</v-icon
              ></b
            >
          </p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="parent_email"
            label="Enter Parent Email / Username"
            name="parent_email"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3" md="2" v-if="!check_for_duplicate_data">
          <p>
            <b
              >Primary Number<v-icon color="error" v-if="!this.org_id == 'zeal'"
                >*</v-icon
              ></b
            >
          </p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="primary_no"
            name="primary_no"
          ></v-text-field>
        </v-col>
          <v-col cols="12" sm="3" md="2" v-else>
          <p>
            <b
              >Primary Numberrrr<v-icon color="error" v-if="!this.org_id == 'zeal'"
                >*</v-icon
              ></b
            >
          </p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="primary_no"
            name="primary_no"
            @change="checkforaadharno()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Personal Email</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="email"
            name="email"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Secondary Number</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="secondary_no"
            name="secondary_no"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Father Name</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="father_name"
            name="father_name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Mother Name</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="mother_name"
            name="mother_name"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="2">
          <p><b>Father Contact</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="father_contact"
            name="father_contact"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Father Email</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="father_email"
            name="father_email"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Mother Contact</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="mother_contact"
            name="mother_contact"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Mother Email</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="mother_email"
            name="mother_email"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <p><b>Guardian Name</b></p>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="guardian_name"
            name="guardian_name"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="3">
          <p><b>Present Address</b></p>
          <v-textarea
            outlined
            name="input-7-4"
            v-model="present_address"
            label="Enter Present Address"
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <p><b>Permanent Address</b></p>
          <v-textarea
            outlined
            name="input-7-4"
            v-model="pernamant_address"
            label="Enter Permanent Address"
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <p><b>Image</b></p>
          <v-file-input @change="Preview_image" v-model="image"></v-file-input>
          <v-img :src="url"></v-img>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-btn color="primary" @click="save()" :loading="loader">Save</v-btn>
      </v-row>
    </v-card>

    <v-dialog
      v-model="show_username"
      max-width="600px"
      v-if="show_username == true"
    >
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Credentials </strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" dense>
            <v-col cols="12" sm="8">
              <p>
                <b>Student Username - {{ student_username }}</b>
              </p>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="8">
              <p>
                <b>Parent Username - {{ parent_username }}</b>
              </p>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <center>
              Note* - Username And Password Are Same For Both Users....
            </center>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button" @click="show_username = false">Close</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    check_for_duplicate_data:false,
    url: "",
    src: null,
    image: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    loader: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    generate_parent_email: true,
    color: "",
    showstudentdetailscard: false,
    subject_offerings: "",
    installments: "",
    show_info_card: false,
    generate_grno: false,
    grno: "",
    crs_off: "",
    ay_list: [],
    sem_list: [],
    standard_list: [],
    stream_list: [],
    ay: "",
    curreny_academicyear: "",
    sem: "",
    standard: "",
    stream: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    gender_list: [],
    gender: "",
    parent_email: "",
    blood_group_list: [],
    blood_group: "",
    quota_list: [],
    quota: "",
    category_list: [],
    category: "",
    roll_no: "",
    email: "",
    primary_no: "",
    secondary_no: "",
    aadhar_no: "",
    mother_name: "",
    guardian_name: "",
    pernamant_address: "",
    present_address: "",
    parent_username: "",
    student_username: "",
    show_username: false,
    serial_track: "",
    division_list: [],
    division: "",
    org_id: "",
    father_name: "",
    mother_email: "",
    mother_contact: "",
    father_email: "",
    father_contact: "",
    caste_list: [],
    stud_caste: "",
    house_list: [],
    stud_house: "",
    religion_list:"",stud_religion:"",
  }),
  methods: {
    checkforaadharno() {
      this.loader = true;
      const formData = {
        aadhar_no: this.aadhar_no,
        primary_no: this.primary_no
      };
      // this.showstudentdetailscard = false;
      axios
        .post("/Admission/checkforaadharno", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            return;
          }
          if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getNextPRN() {
      this.loader = true;
      const formData = {
        ay: this.ay,
      };
      this.showstudentdetailscard = false;
      axios
        .post("/Admission/getNextPRN", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.serial_track = res.data.serial_track;
            this.curreny_academicyear = res.data.curreny_academicyear;
            this.showstudentdetailscard = false;
            this.show_info_card = true;
            return;
          }
          if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    clearList() {
      //this.standard_list=[]
      (this.standard = ""), (this.division = ""), (this.division_list = []);
      this.setFlag();
    },
    setFlag() {
      if (
        this.standard == "" ||
        (this.standard == null && this.division == " ") ||
        this.division == null
      ) {
        this.showstudentdetailscard = false;
        return;
      } else {
        this.showstudentdetailscard = true;
        return;
      }
    },
    getDivisions(standard) {
      //  alert("standard::"+standard)
      this.loader = true;
      const formData = {
        ay: this.ay,
        standard: standard,
      };
      this.showstudentdetailscard = false;
      axios
        .post("/Admission/getDivisions", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.division_list = res.data.division_list;
            this.subject_offerings = res.data.subject_offerings;
            this.installments = res.data.installments;
            this.crs_off = res.data.crs_off;
            if (this.division_list.length <= 0) {
              this.showSnackbar(
                "#b71c1c",
                "Division Offering Not Found...Please Offer Divisions For This Standard.."
              );
              this.showstudentdetailscard = false;
              return;
            }
            this.show_info_card = true;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    clearData() {
      (this.ay = ""),
        (this.sem = ""),
        (this.standard = ""),
        (this.stream = ""),
        (this.first_name = ""),
        (this.middle_name = ""),
        (this.last_name = ""),
        (this.gender = ""),
        (this.blood_group = ""),
        (this.quota = ""),
        (this.category = ""),
        (this.roll_no = ""),
        (this.email = ""),
        (this.primary_no = ""),
        (this.secondary_no = ""),
        (this.aadhar_no = ""),
        (this.mother_name = ""),
        (this.guardian_name = ""),
        (this.pernamant_address = ""),
        (this.present_address = ""),
        (this.image = null),
        (this.src = null),
        (this.url = "");
      (this.division = ""),
        (this.division_list = []),
        (this.parent_email = ""),
        (this.generate_grno = false),
        (this.grno = "");
      //this.parent_username="",this.student_username="",this.show_username=false;
    },
    save() {
      if (this.ay == "" || this.ay == null) {
        this.showSnackbar("#b71c1c", "Please Select Academic Year...");
        return;
      }
      //   if(this.stream=="" || this.stream==null){
      //        this.showSnackbar("#b71c1c", "Please Select Stream...");
      //        return
      //   }
      if (this.standard == "" || this.standard == null) {
        this.showSnackbar("#b71c1c", "Please Select standard...");
        return;
      }
      if (this.division == "" || this.division == null) {
        this.showSnackbar("#b71c1c", "Please Select Semester...");
        return;
      }
      if (this.first_name == "" || this.first_name == null) {
        this.showSnackbar("#b71c1c", "Please Enter First Name...");
        return;
      }
      if (this.last_name == "" || this.last_name == null) {
        this.showSnackbar("#b71c1c", "Please Enter Last Name...");
        return;
      }
      if (this.gender == "" || this.gender == null) {
        this.showSnackbar("#b71c1c", "Please Select Gender...");
        return;
      }
      if (this.quota == "" || this.quota == null) {
        this.showSnackbar("#b71c1c", "Please Select Quota...");
        return;
      }
      if (!this.org_id == "zeal") {
        if (this.category == "" || this.category == null) {
          this.showSnackbar("#b71c1c", "Please Select Category...");
          return;
        }
      }
      if (!this.org_id == "zeal") {
        if (!this.generate_parent_email) {
          if (this.parent_email == "" || this.parent_email == null) {
            this.showSnackbar("#b71c1c", "Please Enter Parent Email...");
            return;
          }
        }
        //   if(!this.generate_grno){
        //       if(this.grno=="" || this.grno==null){
        //        this.showSnackbar("#b71c1c", "Please Enter GR Number...");
        //        return
        //   };
      }
      if (!this.org_id == "zeal") {
        if (this.primary_no == "" || this.primary_no == null) {
          this.showSnackbar("#b71c1c", "Please Enter Primary Contact No...");
          return;
        }
      }
      this.loader = true;
      let formData = new FormData();
      formData.append("ay", this.ay);
      formData.append("stream", this.stream);
      formData.append("sem", this.sem);
      formData.append("standard", this.standard);
      //  if(this.division != "" || this.division != null){
      // alert("division::"+this.division)
      // formData.append("div_id", this.division.div_id);
      formData.append("div_off_id", this.division);
      //   }
      // formData.append("grno", this.grno);
      formData.append("gender", this.gender);
      formData.append("quota", this.quota);
      formData.append("blood_group", this.blood_group);
      formData.append("category", this.category);
      formData.append("primary_no", this.primary_no);
      formData.append("secondary_no", this.secondary_no);
      formData.append("first_name", this.first_name);
      formData.append("middle_name", this.middle_name);
      formData.append("last_name", this.last_name);
      formData.append("dob", this.date);
      formData.append("image", this.image);
      formData.append("aadhar_no", this.aadhar_no);
      formData.append("email", this.email);
      formData.append("parent_email", this.parent_email);
      formData.append("roll_no", this.roll_no);
      formData.append("mother_name", this.mother_name);
      formData.append("guardian_name", this.guardian_name);
      formData.append("present_address", this.present_address);
      formData.append("pernamant_address", this.pernamant_address);
      formData.append("father_name", this.father_name);
      formData.append("mother_email", this.mother_email);
      formData.append("mother_contact", this.mother_contact);
      formData.append("father_email", this.father_email);
      formData.append("father_contact", this.father_contact);
      formData.append("stud_caste", this.stud_caste);
      formData.append("stud_house", this.stud_house);
      formData.append("stud_religion", this.stud_religion);
      axios
        .post("/Admission/saveStudentinfo", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("#4caf50", "Student Added Successfully...!");
            this.loader = false;
            this.parent_username = res.data.parent_username;
            this.student_username = res.data.student_username;
            this.onLoad();
            this.show_username = true;
            this.clearData();
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    onLoad() {
      axios
        .post("/Admission/getInitialData")
        .then((res) => {
          if (res.data.flag == "Yes") {
            (this.ay_list = res.data.ay_list),
              (this.sem_list = res.data.sem_list),
              (this.standard_list = res.data.standard_list),
              (this.stream_list = res.data.stream_list),
              (this.gender_list = res.data.gender_list),
              (this.blood_group_list = res.data.blood_group_list),
              (this.quota_list = res.data.quota_list),
              (this.category_list = res.data.category_list);
            this.serial_track = res.data.serial_track;
            (this.ay = res.data.curreny_ay),
              (this.generate_parent_email = res.data.generate_parent_email);
            (this.caste_list = res.data.caste_list),
              (this.house_list = res.data.house_list);
              (this.religion_list = res.data.religion_list);
            this.curreny_academicyear = res.data.curreny_academicyear;
            this.check_for_duplicate_data = res.data.check_for_duplicate_data;
            //this.generate_grno=res.data.generate_grno
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            return;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
    this.org_id = localStorage.getItem("EPS-tenant");
  },
  watch: {},
};
</script>
<style scoped>
</style>
